var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3846 13H13M1 13L4.35846 12.301C4.53675 12.2639 4.70046 12.1732 4.82903 12.0404L12.3473 4.2706C12.7077 3.89808 12.7075 3.29424 12.3467 2.92203L10.7541 1.27888C10.3935 0.906821 9.80916 0.907074 9.44885 1.27944L1.92982 9.05003C1.8015 9.18264 1.71389 9.35138 1.67793 9.53516L1 13Z",
    stroke: "#929292",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.6c1bbe0b96feaacdab423acb88e06a5c.svg";
export { ForwardRef as ReactComponent };